import { makeStyles, Paper, Theme } from "@material-ui/core";

const useStyles = makeStyles((theme: Theme) => ({
	root: {
		margin: theme.spacing(0, 2),
		padding: theme.spacing(2),
	},
}));

export default function Home() {
	const classes = useStyles();

	return <Paper className={classes.root}>Fejlesztés alatt</Paper>;
}
